export default "__VITE_ASSET__u2o_ZPmK__"